import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import OrderStore from '../../../stores/OrderStore';
import useStoreState from '../../../stores/useStoreState';

import Price from '../../general/Price';

const VoucherCodeLineItem = () => {
    const appliedVoucher = useStoreState(OrderStore, (store) => store.getAppliedVoucher());
    const order = useStoreState(OrderStore, (store) => store.getCurrent());

    if (!appliedVoucher) {
        return null;
    }

    const label = appliedVoucher.campaignName || (appliedVoucher.code || '').toUpperCase();
    const displayAmount = Math.min(appliedVoucher.amount, order.getTotalPrice());

    return (
        <Row key="voucherCode" className="order-summary-narrow__totals__tickets margin-top--s margin-bottom--xs">
            <Col xs={8}>
                {label}
                <span className="sr-only">. </span>
            </Col>
            <Col xs={4} className="text-right price">
                <span style={{ whiteSpace: 'nowrap' }}>-<Price price={displayAmount} /></span>
                <span className="sr-only">. </span>
            </Col>
        </Row>
    );
};

export default VoucherCodeLineItem;
